import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const CatalogueProductsList = lazy(() => import('../../pages/catalogue/products/ProductsList'));
const AddCatalogueProduct = lazy(() => import('../../pages/catalogue/products/Add'));
const EditItem = lazy(() => import('../../pages/catalogue/products/Edit'));

const AxiosRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/`} component={CatalogueProductsList} />
            <Route exact path={`${path}/products`} component={CatalogueProductsList} />
            <Route exact path={`${path}/products/add`} component={AddCatalogueProduct} />
            <Route exact path={`${path}/products/:id`} component={EditItem} />
        </Switch>
    );
};

export default AxiosRoute;
